"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _context = require("../context");

var _utils = require("../utils");

var _avatarConstants = require("./avatarConstants");

var _propTypes = require("./propTypes");

var _core = require("@emotion/core");

var _excluded = ["theme"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var AvatarImageBase = (0, _context.styledWithTheme)('div', {
  // stylelint-disable-next-line
  shouldForwardProp: (0, _utils.filterProps)(['src', 'margin', 'badgeStyle', 'borderRadius'])
})(function (_ref) {
  var theme = _ref.theme,
      props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var avatarBadge = props.badgeStyle ? {
    borderStyle: 'solid',
    borderWidth: props.badgeStyle.badgeBorderWidth,
    borderColor: theme.selectors.colorOrNull(props.badgeStyle.badgeColor) || props.badgeStyle.badgeColor || 'transparent'
  } : {};
  return _objectSpread(_objectSpread(_objectSpread({}, avatarBadge), (0, _utils.getSpacingStyles)(['width', 'height', 'margin'], props, theme.selectors.space)), {}, {
    flexShrink: 0,
    backgroundColor: theme.selectors.color('neutral10'),
    backgroundImage: "url('".concat(props.src, "')"),
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    borderRadius: theme.selectors.radius(props.borderRadius)
  });
});

var AvatarImage = function AvatarImage(_ref2) {
  var id = _ref2.id,
      badgeStyle = _ref2.badgeStyle,
      imageAltText = _ref2.imageAltText,
      borderRadius = _ref2.borderRadius,
      shouldAnnounceImageAltText = _ref2.shouldAnnounceImageAltText,
      size = _ref2.size,
      source = _ref2.source;
  var uniqueId = (0, _react.useMemo)(function () {
    return (0, _utils.getUniqueId)();
  }, []);
  var componentId = id || uniqueId;
  return (0, _core.jsx)(AvatarImageBase, {
    id: "".concat(_avatarConstants.COMPONENT_IMAGE_ID, "-").concat(componentId),
    "aria-label": shouldAnnounceImageAltText ? imageAltText : undefined,
    badgeStyle: badgeStyle,
    "data-test-component": "StencilAvatarImage",
    height: size,
    borderRadius: borderRadius,
    role: shouldAnnounceImageAltText ? 'img' : undefined,
    src: source,
    width: size
  });
};

AvatarImage.displayName = 'AvatarImage';
AvatarImage.defaultProps = {
  imageAltText: '',
  shouldAnnounceImageAltText: false
};
var AvatarImageWithDocs = (0, _stencilReactDesc.describe)(AvatarImage).description('Used to graphically represent Amazonians.');
AvatarImageWithDocs.propTypes = _objectSpread({}, _propTypes.avatarImagePropTypes);
var _default = AvatarImage;
exports.default = _default;